import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "country-jp", class: _vm.$x.nsAddressForm },
    [
      _c(
        "div",
        { class: _vm.$x.dualColumn },
        [
          _c(VTextField, {
            ref: "postalCodeField",
            staticClass: "flex-column",
            class: _vm.$x.firstCol,
            attrs: {
              name: "postalCode",
              maxlength: "8",
              required: "",
              "validate-on-blur": "",
              "persistent-hint": _vm.warning,
              hint: _vm.warning ? "" : "",
              label: _vm.t.postalCodeLabel,
              rules: _vm.postalCodeRules,
            },
            on: { blur: _vm.onBlur, input: _vm.postCodeChanged },
            model: {
              value: _vm.address.postalCode,
              callback: function ($$v) {
                _vm.$set(
                  _vm.address,
                  "postalCode",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "address.postalCode",
            },
          }),
          _vm._v(" "),
          _c("NsSelect", {
            class: [
              ((_obj = {}),
              (_obj[_vm.$x["disabled"]] = _vm.postCodeLookedUp),
              _obj),
              _vm.$x["jp-regions"],
            ],
            attrs: {
              items: _vm.regions,
              name: "region",
              label: _vm.t.regionLabel,
              rules: _vm.stateRules,
              disabled: _vm.postCodeLookedUp,
            },
            on: { blur: _vm.onBlur, input: _vm.addressUpdated },
            model: {
              value: _vm.address.region,
              callback: function ($$v) {
                _vm.$set(_vm.address, "region", $$v)
              },
              expression: "address.region",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$x.dualColumn },
        [
          _c(VTextField, {
            ref: "addressCity",
            staticClass: "flex-column",
            class: _vm.$x.firstCol,
            attrs: {
              name: "city",
              maxlength: "25",
              required: "",
              "validate-on-blur": "",
              label: _vm.t.cityLabel,
              rules: _vm.cityRules,
              readonly: _vm.postCodeLookedUp,
            },
            on: { blur: _vm.onBlur, input: _vm.addressUpdated },
            model: {
              value: _vm.address.city,
              callback: function ($$v) {
                _vm.$set(
                  _vm.address,
                  "city",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "address.city",
            },
          }),
          _vm._v(" "),
          _c(VTextField, {
            ref: "addressDistrict",
            staticClass: "flex-column",
            attrs: {
              name: "district",
              maxlength: "25",
              required: "",
              "validate-on-blur": "",
              label: _vm.t.districtLabel,
              rules: _vm.cityRules,
            },
            on: { blur: _vm.onBlur, input: _vm.addressUpdated },
            model: {
              value: _vm.address.district,
              callback: function ($$v) {
                _vm.$set(
                  _vm.address,
                  "district",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "address.district",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(VTextField, {
        staticClass: "flex-column",
        attrs: {
          name: "address1",
          maxlength: "32",
          "validate-on-blur": "",
          label: _vm.t.address1Label,
          rules: _vm.address1JPRules,
        },
        on: { blur: _vm.onBlur, input: _vm.addressUpdated },
        model: {
          value: _vm.address.address1,
          callback: function ($$v) {
            _vm.$set(
              _vm.address,
              "address1",
              typeof $$v === "string" ? $$v.trim() : $$v
            )
          },
          expression: "address.address1",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }